import type { ChannelMetrics } from '@/api/types'

export type Trend = 'up' | 'down' | 'flat' | 'unknown'
export type Status = 'ok' | 'warning' | 'closed'

/** Success ratio (%) under which a site is flagged "Low". */
export const LOW_SUCCESS_RATIO = 80
/** Closed ratio (%) over which a site is flagged "Closed". */
export const HIGH_CLOSED_RATIO = 30

// Ratios move a lot while a synchronisation runs, so the trend only means something once it is nearly done.
export function trendOf(row: ChannelMetrics): Trend {
  if (row.referenceSuccessRatio === null || row.progress < 95) return 'unknown'
  const delta = row.successRatio - row.referenceSuccessRatio
  if (Math.abs(delta) <= 1) return 'flat'
  return delta > 0 ? 'up' : 'down'
}

export function statusOf(row: ChannelMetrics): Status {
  if (row.successRatio < LOW_SUCCESS_RATIO) return 'warning'
  if (row.closedRatio > HIGH_CLOSED_RATIO) return 'closed'
  return 'ok'
}

export const isInProgress = (row: ChannelMetrics): boolean => row.progress < 100
